import { onBeforeUnmount, onMounted } from 'vue'

// Adds `is-visible` to every [data-reveal] element inside root once it scrolls into view.
export function useReveal(root) {
  let observer
  onMounted(() => {
    const items = root.value?.querySelectorAll('[data-reveal]') || []
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    if (!('IntersectionObserver' in window) || reducedMotion) {
      items.forEach(item => item.classList.add('is-visible'))
      return
    }
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return
        entry.target.classList.add('is-visible')
        observer.unobserve(entry.target)
      })
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' })
    items.forEach(item => observer.observe(item))
  })
  onBeforeUnmount(() => observer?.disconnect())
}
